module.exports = __webpack_public_path__ + "static/media/woo6.eca8f531.png";